const numericBalance = (value) => Number(value) || 0;

export const hasNegativeStatisticsBalance = (
  employee,
  { isCrossDepartment = false, useCombinedAccounts = false } = {},
) => {
  if (useCombinedAccounts) {
    return numericBalance(
      isCrossDepartment
        ? employee?.subaccount_combined_balance
        : employee?.combined_balance,
    ) < 0;
  }

  const breakfastBalance = numericBalance(
    isCrossDepartment
      ? employee?.subaccount_breakfast_balance
      : employee?.breakfast_balance,
  );
  const drinksBalance = numericBalance(
    isCrossDepartment
      ? employee?.subaccount_drinks_balance
      : employee?.drinks_sweets_balance,
  );

  return breakfastBalance < 0 || drinksBalance < 0;
};

export const filterStatisticsEntries = (
  entries,
  useCombinedAccounts,
  onlyNegative,
) => (
  onlyNegative
    ? entries.filter(({ employee, isCrossDepartment }) => (
        hasNegativeStatisticsBalance(employee, {
          isCrossDepartment,
          useCombinedAccounts,
        })
      ))
    : entries
);
